import iso9001 from '../../assets/certifications/iso-9001.webp'
import iso14001 from '../../assets/certifications/iso-14001.webp'
import iso45001 from '../../assets/certifications/iso-45001.webp'
import aiota from '../../assets/certifications/aiota.webp'
import bifma from '../../assets/certifications/bifma.webp'
import greenguard from '../../assets/certifications/greenguard.webp'

export type Certification = {
    title: string
    // Set once the certificate PDF is uploaded; until then the card is not a link.
    pdfUrl?: string
    // First page of that PDF, rendered to webp — see scripts/build-certification-thumbnails.sh.
    thumbnail?: string
}

// PDFs live in public/certifications/ so they are served as-is, the same way the
// brochure is — they are documents to hand out, not assets to bundle.
export const certifications: Certification[] = [
    { title: 'ISO 9001:2015', pdfUrl: '/certifications/iso-9001.pdf', thumbnail: iso9001 },
    { title: 'ISO 14001:2015', pdfUrl: '/certifications/iso-14001.pdf', thumbnail: iso14001 },
    { title: 'ISO 45001:2018', pdfUrl: '/certifications/iso-45001.pdf', thumbnail: iso45001 },
    { title: 'AIOTA', pdfUrl: '/certifications/aiota.pdf', thumbnail: aiota },
    { title: 'BIFMA', pdfUrl: '/certifications/bifma.pdf', thumbnail: bifma },
    { title: 'GREEN GUARD', pdfUrl: '/certifications/greenguard.pdf', thumbnail: greenguard },
]
